<app-pan-section-header title="Total Disconnected Cameras By Date" class="mb-2"> </app-pan-section-header>

@if (isLoadingTimeSeries()) {
  <div class="mt-4 h-[256px]">
    <app-pan-blank-slate> <app-pan-spinner></app-pan-spinner> Loading time series... </app-pan-blank-slate>
  </div>
} @else {
  <div class="mt-4 w-full h-[256px] flex justify-center">
    <canvas
      baseChart
      [data]="barChartData()"
      [options]="barChartOptions()"
      [legend]="barChartLegend()"
      [type]="'bar'"
      data-testid="camera_health_canvas"
    >
    </canvas>
  </div>
}

<app-pan-section-header title="Camera List" class="my-2">
  <app-pan-button action color="primary" (click)="export()" icon="download" [disabled]="cameras().length === 0"> Export </app-pan-button>
</app-pan-section-header>

@if (isLoading()) {
  <app-pan-blank-slate> <app-pan-spinner></app-pan-spinner> Loading... </app-pan-blank-slate>
} @else {
  <ag-grid-angular #cameraGrid [rowData]="cameras()" [columnDefs]="tableColumns" [gridOptions]="tableDef"></ag-grid-angular>
}
